module.exports = "<div class=\"category-icon-wrapper\" [ngClass]=\"{'has-label': showLabel}\">\r\n  <i *ngIf=\"icon || iconName\" class=\"material-icons\" [title]=\"category | titleCase\">{{icon || iconName}}</i> {{ showLabel ? title ? title : (category | titleCase) : '' }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/category-icon/category-icon.component.html
// module id = ../../../../../src/app/category-icon/category-icon.component.html
// module chunks = main